import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import RightsCheck from "../General/RightsCheck";

const levelLabels = {
  1: "1st Level",
  2: "2nd Level",
  3: "3rd Level",
};

const PrintBudgetHeadWise = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(true);
  const [listOfLedger, setLedger] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [closingDebitTotal, setClosingDebitTotal] = useState("");
  const [closingCreditTotal, setClosingCreditTotal] = useState("");
  const [budgetTotal, setBudgetTotal] = useState("");
  const [balanceTotal, setBalanceTotal] = useState("");
  const [filterLabel, setFilterLabel] = useState("");

  useEffect(() => {
    document.title = "Print Budget Head Wise";
    document.body.classList.add("print-body");
    return () => {
      document.body.classList.remove("print-body");
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const fYear = parseInt(params.get("FYear") || "0", 10) || 0;
    const endDate = params.get("EndDate") || "";
    const accountLevel = parseInt(params.get("AccountLevel") || "1", 10) || 1;
    const showZero = params.get("ShowZeroAccounts") === "1";
    const showThirdOnly = params.get("ShowThirdOnly") === "1";

    const parts = [`Year ${fYear}`, levelLabels[accountLevel] || `Level ${accountLevel}`];
    if (endDate) {
      parts.push(`As on ${moment(endDate).format("DD/MM/YYYY")}`);
    }
    if (!showZero) {
      parts.push("Zero accounts hidden");
    }
    if (showThirdOnly && accountLevel !== 3) {
      parts.push("3rd level only");
    }
    parts.push("Budget allocation > 0");
    setFilterLabel(parts.join(" · "));

    if (!fYear || !endDate) {
      setLoading(false);
      return;
    }

    axios({
      method: "post",
      url: config.base_url + "Accounts/GetBudgetHeadWise",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        pageNo: 1,
        pageSize: 10000,
        FYear: fYear,
        EndDate: endDate,
        AccountLevel: accountLevel,
        ShowZeroAccounts: showZero,
        ShowThirdOnly: showThirdOnly,
      },
    })
      .then((response) => {
        if (response.data?.status_code === 1 && Array.isArray(response.data.ListofRecords)) {
          setLedger(response.data.ListofRecords);
          setTotalRecords(response.data.totalRecords || 0);
          setClosingDebitTotal(response.data.ClosingDebitTotal || "");
          setClosingCreditTotal(response.data.ClosingCreditTotal || "");
          setBudgetTotal(response.data.BudgetTotal || "");
          setBalanceTotal(response.data.BalanceTotal || "");
        } else {
          setLedger([]);
          setTotalRecords(0);
        }
        setLoading(false);
      })
      .catch(() => {
        setLedger([]);
        setLoading(false);
      });
  }, [AccessKey, UserID, MemberType]);

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => {
        const code = item.Selected_Account?.Account_code || "";
        const rowStyle = code.length === 2
          ? { backgroundColor: "#fddede" }
          : code.length === 5
            ? { backgroundColor: "#d9f7fe" }
            : undefined;
        return (
          <tr key={index} style={rowStyle}>
            <td>{index + 1}</td>
            <td>{item.Selected_Account?.Account_code}</td>
            <td>{item.Selected_Account?.Account_desc}</td>
            <td className="text-end">{item.ClosingDebit}</td>
            <td className="text-end">{item.ClosingCredit}</td>
            <td className="text-end">{item.Budget_Allocation}</td>
            <td className="text-end">{item.Balance}</td>
          </tr>
        );
      });
    }

    return (
      <tr>
        <td colSpan={7}>
          <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <RightsCheck />
      <Page orientation="portrait" size="a4">
        <PrintHeader title="Budget Head Wise" />
        {filterLabel ? (
          <p className="small mb-2" style={{ fontSize: "10pt" }}>
            {filterLabel}
          </p>
        ) : null}
        <table className="table table-sm table-bordered table-print w-100">
          <thead>
            <tr>
              <th colSpan={7} className="text-end">
                Total records: {totalRecords}
              </th>
            </tr>
            <tr>
              <th>Sr#</th>
              <th>Account Code</th>
              <th>Account Name</th>
              <th colSpan={2} className="text-center">Utilized Budget</th>
              <th className="text-end">Budget Allocation</th>
              <th className="text-end">Balance</th>
            </tr>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th className="text-center">Debit</th>
              <th className="text-center">Credit</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="text-center" colSpan={7}>
                  <Spinner animation="border" role="status" />
                </td>
              </tr>
            ) : (
              renderLedger()
            )}
          </tbody>
          {!loading && listOfLedger.length > 0 && (
            <tfoot>
              <tr>
                <th colSpan={3} className="text-end">
                  Grand Total
                </th>
                <th className="text-end">{closingDebitTotal}</th>
                <th className="text-end">{closingCreditTotal}</th>
                <th className="text-end">{budgetTotal}</th>
                <th className="text-end">{balanceTotal}</th>
              </tr>
            </tfoot>
          )}
        </table>
      </Page>
    </>
  );
};

export default PrintBudgetHeadWise;
